import { useTranslation } from 'react-i18next';
import {
  Box, CircularProgress, Paper, Tooltip,
} from '@mui/material';
import { useState } from 'react';
import Image from 'next/image';
import { FiFile } from 'react-icons/fi';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

export function FilePreview(props) {
  const {
    alt,
    fixedSize,
    height,
    onClick,
    size = 100,
    sx,
    url,
  } = props;
  const { t } = useTranslation();
  const styles = {};

  const fileExtension = `.${url?.split('.')
    .pop() ?? 'unknown'}`.toLowerCase()
    .trim();

  if (fileExtension === '.pdf') {
    styles.minWidth = '80px';
  }

  return (
    <Tooltip
      placement="top"
      title={t('components.atoms.FilePreview.showFilePreviewTooltip')}
    >
      <Paper
        onClick={onClick}
        sx={{
          ...styles,
          ...sx,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          cursor: 'pointer',
          transition: (theme) => theme.transitions.create(['opacity']),
          '&:hover, &:focus': {
            opacity: 0.75,
          },
        }}
        variant="outlined"
      >
        {isPreviewSupported(url) ? (
          <ImagePreview
            alt={alt}
            fixedSize={fixedSize}
            height={height}
            size={size}
            url={url}
          />
        ) : (
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            sx={{
              color: 'primary.main',
              width: 80,
              height: 80,
            }}
          >
            <FiFile size={32} />
          </Box>
        )}
      </Paper>
    </Tooltip>
  );
}

function ImagePreview(props) {
  const {
    alt,
    fixedSize,
    height,
    size = 100,
    url,
  } = props;
  const [loading, setLoading] = useState(true);

  const handleImageLoaded = () => {
    setLoading(false);
  };

  return (
    <div style={{
      position: 'relative',
      width: fixedSize ? size : '100%',
      height: fixedSize ? size : height ?? size,
      margin: '0 auto',
      minHeight: '100%',
    }}
    >
      {loading && (
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CircularProgress
            color="primary"
            size={25}
            sx={{ display: 'block' }}
            variant="indeterminate"
          />
        </div>
      )}
      <Image
        alt={alt}
        fill
        onLoad={handleImageLoaded}
        src={url}
        style={{ objectFit: 'cover' }}
      />
    </div>
  );
}

const PREVIEW_SUPPORTED_FILES = [
  '.png',
  '.gif',
  '.jpg',
  '.jpeg',
  '.svg',
];

function isPreviewSupported(url) {
  return false;
  /*
  if (!url) {
    return false;
  }

  url = url.toLowerCase();
  return PREVIEW_SUPPORTED_FILES.some((ext) => url.endsWith(ext));
   */
}
